import {
  URINALYSIS_BLOOD_LEUCOCYTES_OPTIONS,
  URINALYSIS_KETONES_OPTIONS,
  urinalysisLabelFor,
} from "features/pregnancy/constants/urinalysisOptions";

export const buildLegacyUrinalysis = (values) => {
  const parts = [];
  if (values.urinalysisGlucose && values.urinalysisGlucose !== "NEGATIVE")
    parts.push(`Glucose ${values.urinalysisGlucose}`);
  if (values.urinalysisProtein && values.urinalysisProtein !== "NEGATIVE")
    parts.push(`Protein ${values.urinalysisProtein}`);
  // Graded now, so the summary states the grade rather than "positive" (KIN-2041), and states it
  // the way the dropdown does — "2+", not the TWO_PLUS code behind it. Nitrites is handled
  // just below, for a reason specific to what POSITIVE means on it.
  const graded = (label, value, options) => {
    if (!value || value === "NEGATIVE") return;
    parts.push(`${label} ${urinalysisLabelFor(options, value)}`);
  };

  graded("Ketones", values.urinalysisKetones, URINALYSIS_KETONES_OPTIONS);
  graded("Blood", values.urinalysisBlood, URINALYSIS_BLOOD_LEUCOCYTES_OPTIONS);
  graded("Leucocytes", values.urinalysisLeucocytes, URINALYSIS_BLOOD_LEUCOCYTES_OPTIONS);
  /*
   * Not run through `graded`: on the graded fields POSITIVE is the legacy "no grade recorded"
   * value, but for nitrites it is the real result the strip reports, so it reads plainly.
   * Negative and blank fall through, same as every other field here.
   */
  if (values.urinalysisNitrites === "POSITIVE") parts.push("Nitrites Positive");
  return parts.join(", ") || "Negative";
};
